import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import AskComfrim from "../common/confirmSubmit";
import BranchContext from "../context/branch";
import { toast } from "react-toastify";
import styled from "styled-components";
import Input from "./../common/inputfunction";
import Checkbox from "./../goodreceive/checkbox";
import Select2 from "./../common/selectoption";
import { GetQueueDetail, getowner } from "../../services/wms/grabconcept";
import { GetQueuebranch, getdatabranch } from "../../services/wms";
const InputWrapper = styled.div`
  input {
    height: 36px;
    border-radius: 5px;
    ${(props) => (props.error ? "border: 1px solid red" : "")};
  }

  label {
    color: ${(props) => (props.error ? "red" : "")};
  }
`;

const RegisterAccount = () => {
  const history = useHistory();
  const { currentBranch } = useContext(BranchContext);
  const [formdata, setformdata] = useState({ fname: "", lname: "", empid: "" });
  const [error, seterror] = useState({});
  const [isOpen, setisOpen] = useState(false);
  const [onSave, setonSave] = useState(false);
  const [branchid, setbranchid] = useState(0);
  const [getbranch, setgetbranch] = useState([]);
  const [branchname, setbranchname] = useState([]);
  const [branchlist, setbranchlist] = useState([]);
  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (branchid == 0) return;

  //   const loadData = async () => {
  //     const { data: result } = await getdatabranch(
  //       "2023-11-02",
  //       branchid
  //     );

  //     if (result.status === "success") {
  //       // setqueuelist(result.data.list);
  //       // setId(0);
  //     } else {
  //       // setqueuelist([]);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, branchid]);
  useEffect(() => {
    if (!currentBranch) return;
    getdatabranch().then((result) => {
      setgetbranch(
        result.data.data.list.map((item) => {
          return {
            value: [item.branchid, item.branchname],
            label: item.branchname,
          };
        })
      );
    });
  }, [currentBranch]);
  console.log("getbranch",getbranch)
  const handleChangeComId = (event) => {
    setbranchid(event[0]);
    setbranchname(event[1]);
    setbranchlist(event);

     //const result = branchlist.find(event)
    
    setbranchlist([...branchlist, event]);

  };
  console.log("branchlist", branchlist);
  const handleInputChange = (inputKey, data) => {
    setformdata({ ...formdata, [inputKey]: data });
    if (data) {
      seterror({ ...error, [inputKey]: "" });
    }
  };
  const handelDeleteimage = (id) => {
    const sublist = [...branchlist];
    const newdata = sublist.filter((item, index) => index !== id);
    setbranchlist(newdata);
  };
  const handelLoginPage = () => {
    history.push("/login");
  };
  const handelRegister = () => {
    if (!formdata.fname) {
      seterror({ ...error, fname: true });
      return;
    }
    if (!formdata.lname) {
      seterror({ ...error, lname: true });
      return;
    }
    if (!formdata.empid) {
      seterror({ ...error, empid: true });
      return;
    }
    setisOpen(true);
  };
  const onCancel = () => {
    setisOpen(false);
  };

  return (
    <>
      <AskComfrim
        onSave={onSave}
        isOpen={isOpen}
        onCancel={onCancel}
        // onOk={onConfirm}
        message={"ท่านยืนยัน คำขอลงทะเบียน ใช่หรือไม่"}
      />
      <section className="mt-4">
        <div className="container ">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-6 col-md-8 shadow">
              <div className="card-block ">
                <div className="row m-2">
                  <div className="col-md-12 mb-2 mt-2">
                    <h3 className="text-center text-primary fw-bold">
                      <i className="bi bi-book-half me-2"></i> Register
                    </h3>
                  </div>
                </div>
                <div className="row m-3">
                  <div className="col-lg-12 my-2">
                    <Input
                      label="รหัสพนักงาน"
                      name="empid"
                      // register={register}
                      // required
                      // errors={errors.username}
                    />
                  </div>

                  <div className="col-lg-12 my-2">
                    <Input
                      label="ชื่อ"
                      name="Username"
                      // register={register}
                      // required
                      // errors={errors.username}
                    />
                  </div>
                  <div className="col-lg-12 my-2">
                    <Input
                      label="นามสกุล"
                      name="lastname"
                      // register={register}
                      // required
                      // errors={errors.password}
                    />
                  </div>
                  <div className="col-lg-12 my-2">
                    <Input
                      label="ตำแหน่ง"
                      name="position"
                      // register={register}
                      // required
                      // errors={errors.username}
                    />
                  </div>
                  <div className="col-lg-12 my-2">
                    <Input
                      label="เบอร์โทร"
                      name="tel"
                      // register={register}
                      // required
                      // errors={errors.password}
                    />
                  </div>
                  <div className="col-lg-12 col-sm-12 col-xs-12">
                    <Select2
                      label="ค้นหาสาขา HUB"
                      data={getbranch}
                      value={branchid}
                      textProperty="name"
                      valueProperty="_id"
                      onChange={handleChangeComId}
                    />
                  </div>
                  <div className="col-lg-12 my-2">
                    <div className="row">
                      {branchlist &&
                        branchlist.length > 0 &&
                        branchlist.map((item, index) => {
                          return (
                            <div className="col-6" key={index}>
                                <div className="shadow-sm my-1">
                                  <span className="me-2 d-flex justify-content-between ">
                                    <span className="ms-2">{item[0] + " " + item[1]}</span>

                                    <i
                                      className="bi bi-trash text-danger ms-4 "
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handelDeleteimage(index)}
                                    ></i>
                                  </span>
                                </div>
                         
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div className="row my-3 ">
                    <div className="col-auto ">
                      <Checkbox
                        name="id1"
                        // value={chk5}
                        // checked={chk5}
                        // onChange={onChangeChk5}
                        label={"ดูรายงาน"}
                      />
                    </div>
                    <div className="col-auto ">
                      <Checkbox
                        className=""
                        name="id2"
                        // value={chk5}
                        // checked={chk5}
                        // onChange={onChangeChk5}
                        label={"เจ้าหน้าที่ห้องชั่ง"}
                      />
                    </div>

                    <div className="col-lg-6 my-2"></div>
                  </div>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end my-2">
                    <button className="btn btn-secondary me-md-2" type="button">
                      <span className="mx-4">Back</span>
                    </button>
                    <button className="btn btn-primary" type="button">
                      <span className="mx-3">Confirm</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RegisterAccount;
